import { ref, unref } from "vue";
import type { Router, RouteLocationNormalizedLoaded } from "vue-router";

const _router = ref<Router>();

/**
 * This function is used for "vue-router" to work outside of the Vue components.
 * Because importing `useRouter` from "vue-router" doesn't work outside of the Vue components, we must make this workaround to make it work.
 * This pattern is a singleton pattern.
 */
export function useRouter(router?: Router): Router | undefined {
  if (router) {
    _router.value = router;
  }
  return _router.value;
}

/**
 * This function is used for "vue-router" to work outside of the Vue components.
 * Because importing `useRoute` from "vue-router" doesn't work outside of the Vue components, we must make this workaround to make it work.
 */
export function useRoute(): RouteLocationNormalizedLoaded | undefined {
  return unref(_router.value?.currentRoute);
}
